export enum BirdConfigurationError {
    NotConfigured = 'NotConfigured',
    NoChannelSet = 'NoChannelSet',
}
